import logger from './logger.js';
import isObject from './isObject.js';

/**
 * Array of search strings which are not cirital errors and so they will be logged as warnings instead of an errors
 */
const warningOnlyPatterns = [
	// NSL API
	'NSL_BAD_REQUEST'
];

/**
 * Handle an error, construct an error object and send the log
 * @param {Error|string} error Native error object or error message
 * @param {object} app Custom properties to extend error object
 * @param {string} app.code Custom error code to filter out the errors
 * @param {string} app.origin Custom origin label to find out the errors
 * @param {number} [app.status] HTTP status code
 * @param {string} [app.description] Short description of the error
 * @param {object} [app.detail] Any more details
 * @param {'error'|'warn'} [level='error'] Level of the logged message
 * @returns {object}
 */
export default (error, app, level = 'error') => {
	if ((!isObject(error) || typeof error.name !== 'string' || typeof error.message !== 'string') && typeof error !== 'string') {
		throw new Error('Invalid method arguments to appError, "error" should be a string or object with name and message');
	} else if (!isObject(app) || typeof app.code !== 'string' || typeof app.origin !== 'string') {
		throw new Error('Invalid method arguments to appError, "app" should be an Object with code and origin');
	} else {
		const nativeError = typeof error === 'string' ? new Error(error) : error;
		const extractedError = [
			// Standard browser
			'name',
			// Standard browser + Node.js
			'message',
			// Microsoft specific
			'description',
			'number',
			// Mozilla specific
			'fileName',
			'lineNumber',
			'columnNumber',
			// Mozilla + Node.js specific
			'stack',
			// Node.js specific
			'code'
		].reduce((extractedError, property) => { // Create an error object from only required properties
			if (typeof nativeError[property] !== 'undefined') {
				extractedError[property] = nativeError[property];
			}
			return extractedError;
		}, {});
		// Add app details to error for logging
		const expandedError = Object.assign({}, extractedError, {
			app
		});
		// For error level messages, we will be checking the content of the error
		const expandedErrorString = level === 'error' ? JSON.stringify(expandedError) : '';
		// If warning should be logged or if an error should be logged, but the content matches "warning only" patterns, log warning instead
		if (level === 'warn' || level === 'error' && warningOnlyPatterns.some((string) => expandedErrorString.includes(string))) {
			logger.warn(expandedError);
		} else {
			logger.error(expandedError);
		}
		// Remove error stack so we don't expose our code structure outside
		delete expandedError.stack;
		// Return modified error object
		return expandedError;
	}
};
